"use client";

import React from "react";

export type BenefitItem = {
  title: string[] | string;
  description: string;
};

export type IndustryBenefitGridCardProps = {
  item: BenefitItem;
  index: number;
};

export default function IndustryBenefitGridCard({
  item,
  index,
}: IndustryBenefitGridCardProps) {
  const title = Array.isArray(item.title) ? item.title.join(" ") : item.title;

  return (
    <article className="text-white/90 flex flex-col self-start outline-none group">
      {/* 1. Header Index & Top Line */}
      <div className="flex flex-col gap-5 shrink-0">
        <div className="text-white/80 text-[18px] clash-font tracking-widest">
          {String(index + 1).padStart(2, "0")}
        </div>
        <div className="h-px w-full bg-white/10 group-hover:bg-white/30 transition-colors duration-300"></div>
      </div>

      {/* 2. Title */}
      <div className="mt-8 lg:min-h-[90px] flex flex-col justify-start">
        <h3 className="clash-font text-white text-[length:var(--space-20-32)] font-[500] leading-tight">
          {title}
        </h3>
      </div>

      {/* 3. Description (No expand/collapse) */}
      <div className="mt-[12px]">
        <p
          className="text-white/70 leading-relaxed text-[length:var(--primarybtn)]"
          dangerouslySetInnerHTML={{ __html: item.description }}
        />
      </div>
    </article>
  );
}
